import React, { useState, useRef, useEffect } from "react"; // useEffect kept for LanguageButton
import { useNavigate } from "react-router-dom";
import {
  FiSearch,
  FiUser,
  FiHeart,
  FiShoppingCart,
  FiGlobe,
} from "react-icons/fi";
import SearchModal from "../Header2Comps/SearchModal";
import { useAppContext } from "../AppContext";

const iconBtn = {
  background: "none",
  border: "none",
  color: "#333",
  cursor: "pointer",
  padding: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  transition: "background 0.2s",
  position: "relative",
};

function IconButton({ icon: Icon, label, badge }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      style={{ ...iconBtn, background: hovered ? "rgba(0,0,0,0.06)" : "none" }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label={label}
    >
      <Icon size={22} />
      {badge > 0 && (
        <span
          style={{
            position: "absolute",
            top: 2,
            right: 2,
            background: "#e11d48",
            color: "white",
            fontSize: 10,
            fontWeight: "bold",
            borderRadius: "50%",
            width: 16,
            height: 16,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
          }}
        >
          {badge}
        </span>
      )}
    </button>
  );
}

const languages = [
  { code: "en", label: "English" },
  { code: "ar", label: "العربية" },
  { code: "fr", label: "Français" },
];

function LanguageButton() {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(languages[0]);
  const [hovered, setHovered] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        onClick={() => setOpen((o) => !o)}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Language"
        style={{
          ...iconBtn,
          background: hovered || open ? "rgba(0,0,0,0.06)" : "none",
          gap: 5,
          borderRadius: 20,
          padding: "6px 10px",
        }}
      >
        <FiGlobe size={20} />
        <span className="h2-lang-label" style={{ color: "#333", fontSize: 13, fontWeight: 500 }}>
          {selected.code.toUpperCase()}
        </span>
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 8px)",
            right: 0,
            background: "#ffffff",
            border: "1px solid rgba(0,0,0,0.1)",
            borderRadius: 8,
            overflow: "hidden",
            minWidth: 130,
            zIndex: 999,
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
          }}
        >
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => {
                setSelected(lang);
                setOpen(false);
              }}
              style={{
                display: "block",
                width: "100%",
                background:
                  selected.code === lang.code ? "rgba(0,0,0,0.05)" : "none",
                border: "none",
                color: "#1a1a1a",
                padding: "10px 16px",
                textAlign: "left",
                cursor: "pointer",
                fontSize: 14,
              }}
            >
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default function Header2() {
  const navigate = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);
  const { favCount, cartCount } = useAppContext();

  return (
    <div
      className="h2-bar"
      style={{
        height: 64,
        backgroundColor: "#ffffff",
        borderBottom: "1px solid rgba(0,0,0,0.08)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
      }}
    >
      {/* Left — Search + Language */}
      <div style={{ display: "flex", alignItems: "center", flex: 1, gap: 4 }}>
        <div onClick={() => setSearchOpen(true)} style={{ cursor: "pointer" }}>
          <IconButton icon={FiSearch} label="Search" />
        </div>
        <LanguageButton />
      </div>

      {searchOpen && <SearchModal onClose={() => setSearchOpen(false)} />}

      <style>{`
        @media (max-width: 480px) {
          .h2-bar { padding: 0 12px !important; }
          .h2-lang-label { display: none; }
        }
      `}</style>

      {/* Center — Logo */}
      <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
        <span
          onClick={() => {
            window.location.href = "/";
          }}
          style={{
            color: "#1a1a1a",
            fontWeight: "800",
            fontSize: 22,
            letterSpacing: 2,
            fontFamily: "serif",
            cursor: "pointer",
          }}
        >
          LEMAQ
        </span>
      </div>

      {/* Right — User, Favorites, Cart */}
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 4,
        }}
      >
        <div
          onClick={() => {
            navigate(`/profile`);
          }}
        >
          <IconButton icon={FiUser} label="Account" />
        </div>
        <div
          onClick={() => {
            navigate(`/favorite`);
          }}
        >
          <IconButton icon={FiHeart} label="Favorites" badge={favCount} />
        </div>

        <div
          onClick={() => {
            navigate(`/cart`);
          }}
        >
          <IconButton icon={FiShoppingCart} label="Cart" badge={cartCount} />
        </div>
      </div>
    </div>
  );
}
